import React, { useEffect, useState } from "react";
import { Spinner, Badge, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FiClock, FiAlertCircle, FiCheckCircle, FiInfo } from "react-icons/fi";

const MediaFornitoriCard = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("ordini_urgenti.json")
      .then((res) => res.json())
      .then((json) => {
        const ordini = json?.STATO_ORDINI?.flat() || [];
        const unMeseFa = new Date();
        unMeseFa.setMonth(unMeseFa.getMonth() - 1);

        const perFornitore = {};

        ordini.forEach((o) => {
          const dataOrdine = new Date(o["Data Ordine"]);
          const dataFine = o["Data Completamento ODP/ODPV"] ? new Date(o["Data Completamento ODP/ODPV"]) : null;

          if (dataOrdine >= unMeseFa && dataFine && !isNaN(dataFine)) {
            const diffDays = Math.ceil((dataFine - dataOrdine) / (1000 * 60 * 60 * 24));
            const fornitore = o["Ragione sociale"] || "N/A";
            const targetSpedizione = parseInt(o["Giorni Spedizione"]) || 0;

            if (!perFornitore[fornitore]) {
              perFornitore[fornitore] = { totaleGiorni: 0, count: 0, target: targetSpedizione, inTargetCount: 0 };
            }
            
            perFornitore[fornitore].totaleGiorni += diffDays;
            perFornitore[fornitore].count += 1;
            
            if (diffDays <= targetSpedizione + 1.5) {
              perFornitore[fornitore].inTargetCount += 1;
            }
          }
        });

        const risultato = Object.entries(perFornitore)
          .map(([fornitore, val]) => {
            const mediaGrezza = val.totaleGiorni / val.count;
            const media = Math.round(mediaGrezza * 2) / 2;
            const percentualeTarget = Math.round((val.inTargetCount / val.count) * 100);

            let pctBg = "#dc3545"; 
            let pctText = "#fff";
            if (percentualeTarget > 50) pctBg = "#28a745"; 
            else if (percentualeTarget >= 25) { pctBg = "#ffc107"; pctText = "#000"; }

            let status = "danger";
            if (media <= val.target) status = "success";
            else if (media <= val.target + 1.5) status = "warning";

            return {
              fornitore,
              media: media.toFixed(1),
              target: val.target,
              count: val.count,
              percentualeTarget,
              pctBg,
              pctText,
              status
            };
          })
          .sort((a, b) => a.fornitore.localeCompare(b.fornitore));

        setData(risultato);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const renderTooltip = (props) => (
    <Tooltip id="info-performance-tooltip" {...props}>
      <div style={{ textAlign: 'left', fontSize: '0.7rem', padding: '5px' }}>
        <strong>SISTEMA:</strong> Target giorni contrattuale.<br/>
        <strong>REALE:</strong> Media effettiva (arrotondata .5).<br/>
        <strong>AFFIDABILITÀ:</strong> % ordini chiusi con ritardo ≤ 1.5gg.<br/>
        <hr style={{ margin: '5px 0', borderColor: 'rgba(255,255,255,0.2)' }} />
        <em>Esempio: Se Target è 2gg e Reale è 3.5gg, lo stato sarà ALERT.</em>
      </div>
    </Tooltip>
  );

  return (
    <div className="ombra card tb" style={{ borderRadius: "12px", border: "1px solid #dee2e6", height: "400px", display: "flex", flexDirection: "column", overflow: "hidden", backgroundColor: "#fff" }}>
      <div className="p-3 bg-light border-bottom d-flex align-items-center">
        <span style={{ fontWeight: "700", fontSize: "0.75rem", color: "#495057", letterSpacing: "1px", marginRight: "8px" }}>
          PERFORMANCE FORNITORI (30gg)
        </span>
        <OverlayTrigger
          placement="right"
          delay={{ show: 100, hide: 400 }}
          overlay={renderTooltip}
        >
          <span style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}>
            <FiInfo size={14} color="#6c757d" />
          </span>
        </OverlayTrigger>
      </div>

      <div className="scroll-container" style={{ flexGrow: 1, overflowY: "auto" }}>
        <style>{`
          .scroll-container::-webkit-scrollbar { width: 4px; }
          .scroll-container::-webkit-scrollbar-thumb { background: #ccc; border-radius: 10px; }
          .badge-small-pct { padding: 2px 6px; font-size: 0.62rem; font-weight: 800; border-radius: 4px; min-width: 38px; display: inline-block; }
          .status-badge-mini { padding: 3px 7px; font-size: 0.6rem; display: inline-flex; align-items: center; gap: 3px; letter-spacing: 0.5px; white-space: nowrap; }
          .table td { padding: 10px 8px !important; }
        `}</style>

        {loading ? (
          <div className="d-flex justify-content-center align-items-center h-100">
            <Spinner animation="border" variant="danger" size="sm" />
          </div>
        ) : (
          <table className="table table-hover mb-0" style={{ fontSize: "0.70rem" }}>
            <thead className="bg-white sticky-top" style={{ zIndex: 1, boxShadow: "0 2px 2px -1px rgba(0,0,0,0.05)" }}>
              <tr>
                <th className="border-0 text-muted ps-3">FORNITORE</th>
                <th className="border-0 text-muted text-center">SISTEMA</th>
                <th className="border-0 text-muted text-center">REALE</th>
                <th className="border-0 text-muted text-center">AFFIDABILITÀ</th>
                <th className="border-0 text-muted text-end pe-3">STATUS</th>
              </tr>
            </thead>
            <tbody>
              {data.map((f, i) => (
                <tr key={i} style={{ verticalAlign: "middle" }}>
                  <td className="ps-3">
                    <div className="fw-bold" style={{ lineHeight: "1.2", color: "#333" }}>
                        {f.fornitore}
                    </div>
                    <div style={{ fontSize: "0.58rem", color: "#999" }}>{f.count} ordini</div>
                  </td>
                  <td className="text-center text-muted">{f.target} gg</td>
                  <td className="text-center fw-bold">{f.media} gg</td>
                  <td className="text-center">
                    <div className="badge-small-pct" style={{ backgroundColor: f.pctBg, color: f.pctText }}>
                      {f.percentualeTarget}%
                    </div>
                  </td>
                  <td className="text-end pe-3">
                    {f.status === "success" && (
                      <Badge bg="success-subtle" className="status-badge-mini text-success border border-success-alpha text-uppercase">
                        <FiCheckCircle size={10} /> Target
                      </Badge>
                    )}
                    {f.status === "warning" && (
                      <Badge bg="warning-subtle" className="status-badge-mini text-warning border border-warning-alpha text-uppercase">
                        <FiClock size={10} /> Alert
                      </Badge>
                    )}
                    {f.status === "danger" && (
                      <Badge bg="danger-subtle" className="status-badge-mini text-danger border border-danger-alpha text-uppercase">
                        <FiAlertCircle size={10} /> Ritardo
                      </Badge>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default MediaFornitoriCard;